import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { RefHandler } from 'react-popper';
import PencilIcon from '@wix/da-shared-react/pkg/Icons/Pencil';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger/constants';
import BiButton from '@wix/da-shared-react/pkg/biLogger/Components/BiButton';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';

import s from './EditConfigButton.scss';

export interface Props {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
  withFTUE?: boolean;
  iconRef?: RefHandler;
}

const EditConfigButton: React.FC<Props> = ({
  className,
  onClick,
  disabled,
  withFTUE,
  iconRef,
}) => {
  const { t } = useTranslation();
  return (
    <BiButton
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        s['edit-button'],
        disabled && s['disabled'],
        className
      )}
      data-role={withFTUE ? 'ftue-control' : 'edit-control'}
      biData={{
        evid: BiEventType.EDIT_WIDGET_CLICK,
      }}
    >
      <PencilIcon
        size={IconSize.MEDIUM}
        className={s['icon']}
        condensed
        containerRef={iconRef}
      />
      <span className={s['edit-button-text']}>{t!('common.edit')}</span>
      {withFTUE && <div className={s['indicator']} />}
    </BiButton>
  );
};

EditConfigButton.displayName = 'EditConfigButton';

export default EditConfigButton;
